import { render, staticRenderFns } from "./PmauPublicHearing.vue?vue&type=template&id=5c45f500&"
import script from "./PmauPublicHearing.vue?vue&type=script&lang=js&"
export * from "./PmauPublicHearing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports